import React from "react"
import { Button, CircularProgress } from "@material-ui/core"
import strings from "strings"
import CreditCost from 'components/shared/CreditCost'

const bgvString = strings.APPLICANT.BGV

const BgvReportActions = ({
                              pdfReportUuid,
                              loading,
                              isSavedReport,
                              isReadOnlyUser,
                              refreshLoading,
                              selectedRow,
                              businessReport,
                              onDownload,
                              onAttach,
                              onBusinessSave,
                              onRefresh,
                              onViewHistory,
                              creditCosts,
                              creditUsageEnabled,
                              hidePdf
                          }) => {

    function getRefreshCreditCost() {
        if (!selectedRow || !creditCosts) return 0;
        const requestType = selectedRow.entityType === 'OWNER' ? 'LEXIS_COMPREHENSIVE_INDIVIDUAL_REPORT' : 'LEXIS_TOP_BUSINESS_REPORT'
        const costObj = creditCosts.find(cost => cost.requestType === requestType);
        return costObj ? costObj.creditCost : 0;
    }

    return (
        <div>
            <span title={!pdfReportUuid && !hidePdf ? bgvString.HINT : ''}>
                {!hidePdf && <>
                    <Button color='primary' variant='outlined' disabled={loading.download || loading.search || !pdfReportUuid || refreshLoading} onClick={onDownload} className='mr-2'>
                        {loading.download ? <CircularProgress size={24} color='inherit' /> : strings.DOWNLOAD_PDF}
                    </Button>
                    <Button color='primary' variant='outlined' disabled={loading.attach || loading.search || !pdfReportUuid || refreshLoading} onClick={onAttach} className='mr-2'>
                        {loading.attach ? <CircularProgress size={24} color='inherit' /> : strings.ATTACH_PDF}
                    </Button>
                </>}
                {!isReadOnlyUser && selectedRow && selectedRow?.entityType !== 'OWNER' && !isSavedReport &&
                    <Button color='primary' variant='contained' disabled={loading.save || loading.search || refreshLoading || !businessReport?.BestSection?.BusinessIds} onClick={() => onBusinessSave(businessReport?.BestSection)} className='mr-2'>
                        {loading.save ? <CircularProgress size={24} color='inherit' /> : strings.Save}
                    </Button>
                }
                {isSavedReport && !isReadOnlyUser && selectedRow && selectedRow.entityType !== 'CONNECTED_BUSINESS' && (
                    <Button
                        color='primary'
                        variant='outlined'
                        disabled={refreshLoading}
                        onClick={() => onRefresh(selectedRow)}
                        className='mr-2'
                        endIcon={creditUsageEnabled && creditCosts ?
                            <CreditCost cost={getRefreshCreditCost()} /> : undefined}
                    >
                        {refreshLoading ? <CircularProgress size={16} color='inherit' /> : 'Refresh Report'}
                    </Button>
                )}
                {isSavedReport && selectedRow && selectedRow.entityType !== 'CONNECTED_BUSINESS' && (
                    <Button
                        variant='outlined'
                        disabled={refreshLoading}
                        onClick={() => onViewHistory(selectedRow)}
                        className='mr-2'
                    >
                        History
                    </Button>
                )}
            </span>
        </div>
    )
}

export default BgvReportActions